import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import isOneClickEnabled from 'infrastructure/security/authentication/OneClick/isOneClickEnabled';
import { useAuthenticationUrl, ONE_CLICK_PATH } from 'infrastructure/security/authentication/authenticationRouting';

interface UserRedirectService {
  checkAuthenticationAndRedirectIfFailed: () => Promise<void>;
}

const useUserRedirectService = (): UserRedirectService => {
  const { getAzureAuthUrl } = useAuthenticationUrl();
  const { isAuthenticated } = useAuthenticationService();

  const checkAuthenticationAndRedirectIfFailed = async (): Promise<void> => {
    const isUserAuthenticated = await isAuthenticated();

    if (!isUserAuthenticated) {
      if (isOneClickEnabled()) {
        window.location.assign(ONE_CLICK_PATH);
      } else {
        window.location.assign(getAzureAuthUrl());
      }
    }
  };

  return {
    checkAuthenticationAndRedirectIfFailed,
  };
};

export default useUserRedirectService;
